// https://developers.facebook.com/docs/facebook-login/web/
export default function FBFunction() {
    this.fb = window.FBFunction;

    this.getLoginStatus = function () {
        return new Promise((resolve, reject) => {
            this.fb.getLoginStatus((response) => {
                if (response?.status == 'connected') {
                    let model = new FBAuthModel();
                    model.setDataFromApi(response.authResponse);
                    resolve(model);
                } else {
                    reject();
                }
            });
        });
    };

    this.login = function () {
        return new Promise((resolve, reject) => {
            this.fb.login((response) => {
                if (response?.status == 'connected') {
                    let model = new FBAuthModel();
                    model.setDataFromApi(response.authResponse);
                    resolve(model);
                } else {
                    reject();
                }
            });
        });
    };

    this.logout = function () {
        return new Promise((resolve) => {
            this.getLoginStatus().then(() => {
                try {
                    this.fb.logout((response) => {
                        resolve(response);
                    });
                } catch (e) {
                    console.log(e);
                    resolve(null);
                }
            });
        });
    };

    this.getFbProfile = function () {
        return new Promise((resolve) => {
            this.fb.getFbProfile((response) => {
                console.log('getFbProfile', response);
                if (response != null) {
                    let model = new FBProfileModel();
                    model.setDataFromApi(response);
                    resolve(model);
                } else {
                    resolve(null);
                }
            });
        });
    };
}

function FBAuthModel() {
    this.accessToken = null;
    this.tokenExpire = null;
    this.tokenExpireIn = null;
    this.graphDomain = null;
    this.signedRequest = null;
    this.userId = null;

    this.setDataFromApi = function (data) {
        this.accessToken = data.accessToken;
        this.tokenExpire = data.data_access_expiration_time;
        this.tokenExpireIn = data.expiresIn;
        this.graphDomain = data.graphDomain;
        this.signedRequest = data.signedRequest;
        this.userId = data.userID;
    };
}

function FBProfileModel() {
    this.id = null;
    this.firstname = null;
    this.lastname = null;
    this.email = null;

    this.setDataFromApi = function (data) {
        this.id = data.id;
        this.firstname = data.first_name;
        this.lastname = data.last_name;
        this.email = data.email;
    };
}
